module.exports = __webpack_public_path__ + "static/img/s-thumb-three.76f5113.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testimonial/s-thumb-three.png
// module id = vYAB
// module chunks = 0